import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { catchError, from, map, mergeMap, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { PrmsOrderSummary } from '../model/prms-order-summary';
import { GoogleService } from './google-service';
import { PrmsOrderShipment } from '../model/prms-order-shipment';
import { DocumentDownload } from '../model/document-download';
import { FileUtils } from '../utils/file-utils';

@Service()
export class PrmsOrdersSearchService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);

  private urlBase = environment.serviceUrl;


  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  public getOrders(searchTerm: string): Observable<PrmsOrderSummary[]> {
    const url = this.urlBase + 'prmsOrders/searchOrders/' + searchTerm;
    return this.http.get<PrmsOrderSummary[]>(url, { headers: this.getRequestHeaders() });
  }

  public getOrderDetails(orderNumber: number): Observable<PrmsOrderSummary> {
    const url = this.urlBase + 'prmsOrders/getDetails/' + orderNumber;
    return this.http.get<PrmsOrderSummary>(url, { headers: this.getRequestHeaders() });
  }

  public getOrderShipments(orderNumber: number): Observable<PrmsOrderShipment[]> {
    const url = this.urlBase + 'prmsOrders/getShipments/' + orderNumber;
    return this.http.get<PrmsOrderShipment[]>(url, { headers: this.getRequestHeaders() });
  }

  public getInvoiceDocument(orderNumber: number, invoiceNumber: string): Observable<Blob> {
    const url = this.urlBase + 'prmsOrders/invoice/pdf/' + orderNumber + '/' + invoiceNumber;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], { type: response.headers.get('Content-Type') });
    }));
  }

    public getBOLDocument(orderNumber: number, pickNumber: string): Observable<Blob> {
    const url = this.urlBase + 'clmEncompassSupport/bol/download' + '/' + orderNumber + '/' + pickNumber;
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], { type: response.headers.get('Content-Type') });
    }));
  }

    public getBOLExists(orderNumber: number, pickNumber: string): Observable<boolean> {
    const url = this.urlBase + 'clmEncompassSupport/bol/fileExists/' + orderNumber + '/' + pickNumber;
    return this.http.get<boolean>(url, { headers: this.getRequestHeaders() });
  }

}
